import React from "react";
import get from "lodash/get";
import includes from "lodash/includes";
import BackArrowButton from "../parts/back-arrow-button";
import submit from "submit-form";
import { getUserToRequest } from "./dashboard/settings/manage-coaches/utils/manage-coaches-utils";

function View(props, { locals }) {
  const onBack = () => {
    const url = `/logout`;
    submit(url, {
      method: "GET",
    });
  };

  return (
    <div id="login-wrapper">
      <form
        method="POST"
        className="h-[100vh] flex flex-col items-center justify-center gap-6"
        data-noreset
      >
        <div className="flex gap-2 items-center">
          <BackArrowButton onBack={onBack} />
          <img
            src="/img/new-icons/MSB-full-logo-extended.svg"
            alt="My Strength Book"
            className="h-12"
          />
        </div>
        <div className="intro">
          <h4>
            You require an active account or coaching invite to access the
            Training App
          </h4>
        </div>
      </form>
    </div>
  );
}

const Upgrade1 = (app) => {
  app.get("/upgrade-1", ({ res, locals, flash, momentTZ }) => {
    const { activeUser, organizationOwner, query } = locals;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);
    const plan = get(userToRequest, "stripe.plan", false);

    if (!query.hideHeader) {
      if (!activeUser) {
        res.redirect("/login");
        return;
      }

      // if the user's plan is a paid account, redirect them to see their subscription
      if (
        !includes(["none", "launch_freeTrial", "free_trial"], plan) &&
        !userToRequest.subscription &&
        !userToRequest.membership
      ) {
        res.redirect("/dashboard/settings/subscription");
        return;
      }
    }

    res.body = <View />;
  });
};

export default Upgrade1;
